<div
  class="relative flex min-h-0 flex-1 flex-col overflow-hidden bg-gradient-to-b from-surface from-[70%] to-surface-brand-default"
>
  <header
    class="mx-4 mt-2 flex flex-shrink-0 items-center justify-between gap-2 border-b border-border-subdued py-2 [&_pm-button_button]:size-6 [&_pm-button_svg]:size-5"
  >
    <div class="flex items-center gap-4">
      <pm-button
        variant="subdued"
        size="normal"
        [icon]="LucideMenu"
        [ariaLabel]="'chat.header.menu'"
        (handleClick)="chat.showHistory()"
      />
      <h2 class="m-0 text-base font-medium leading-[1.3] text-content-default">
        {{ 'chat.header.title' | translate }}
      </h2>
    </div>

    <div class="flex items-center gap-4">
      <pm-button
        variant="subdued"
        size="normal"
        [icon]="LucideEllipsisVertical"
        [pmButtonMenu]="menuConfig()"
        [panelClass]="menuPanelClass"
        xPosition="before"
        [ariaLabel]="'chat.header.options'"
      />

      <pm-button
        variant="subdued"
        size="normal"
        [icon]="LucideX"
        [ariaLabel]="'chat.header.close'"
        (handleClick)="chat.close()"
      />
    </div>
  </header>

  <div
    #content
    class="flex-1 overflow-y-auto px-4 [scrollbar-color:var(--border-color)_transparent] [scrollbar-width:thin] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar]:w-1.5"
  >
    @if (!chat.hasConversation()) {
    <div class="flex min-h-full flex-col justify-center gap-8">
      <div class="flex items-center justify-center gap-2">
        <pm-icon
          [icon]="LucideAstroid"
          size="md"
          class="shrink-0 text-content-interactive-default"
        />
        <pm-h3 elementClass="text-base leading-[1.3] text-content-default">
          @if (firstName()) { {{ 'chat.greeting' | translate: { name:
          firstName() } }} } @else { {{ 'chat.greetingFallback' | translate }} }
        </pm-h3>
      </div>
      <pm-chat-suggestions
        [suggestions]="starterSuggestions()"
        (selected)="onSuggestion($event)"
      />
    </div>
    } @else {
    <div class="flex flex-col gap-6 pb-4 pt-6">
      @for (msg of chat.messages(); track msg.id; let last = $last) { @if
      (msg.role === 'user') {
      <pm-chat-message [role]="'user'" [text]="textOf(msg)" />
      } @else if (msg.role === 'assistant') {
      <div class="flex flex-col gap-3">
        @if (last && showStatus()) {
        <pm-chat-status [status]="chat.status()" />
        } @if (toolCallsFor(msg.id).length) {
        <pm-chat-tool-calls [toolCalls]="toolCallsFor(msg.id)" />
        } @if (textOf(msg)) {
        <pm-chat-message [role]="'assistant'" [text]="textOf(msg)" />
        }
      </div>
      } @if (last) {
      <div class="flex flex-col gap-3">
        @if (msg.role === 'user' && showStatus()) {
        <pm-chat-status [status]="chat.status()" />
        } @switch (chat.status()) { @case ('stopped') {
        <div
          class="flex flex-col items-start gap-2 text-sm leading-snug text-content-default"
        >
          <pm-link
            size="normal"
            text="chat.outcome.continue"
            (handleClick)="chat.continueAnswer()"
          />
        </div>
        } @case ('error-answer') {
        <div
          class="flex flex-col items-start gap-2 text-sm leading-snug text-content-default"
        >
          <p class="m-0">{{ 'chat.outcome.errorAnswer' | translate }}</p>
          <pm-link
            size="normal"
            text="chat.outcome.retry"
            (handleClick)="chat.retry()"
          />
        </div>
        } @case ('no-answer') {
        <div
          class="flex flex-col items-start gap-2 text-sm leading-snug text-content-default"
        >
          <p class="m-0">{{ 'chat.outcome.noAnswerTitle' | translate }}</p>
          <p class="m-0 text-content-subdued">
            {{ 'chat.outcome.noAnswerBody' | translate }}
          </p>
          <pm-link
            size="normal"
            text="chat.outcome.contactSupport"
            (handleClick)="routeToSupport()"
          />
        </div>
        } }
      </div>
      } }
    </div>
    }
  </div>

  <div class="flex-shrink-0 px-4 pt-2">
    <pm-chat-composer />
  </div>

  <footer
    class="mb-2 flex h-8 flex-shrink-0 items-center justify-center px-4 text-center text-[10px] leading-[1.38] text-form-input-content-default"
  >
    {{ 'chat.footer.disclaimer' | translate }}
  </footer>

  @if (chat.view() === 'history') {
  <pm-chat-history />
  }
</div>
